import React, { Component } from 'react';
import _ from 'lodash';
import { Row, Col } from 'antd';
import { ASSET_BASE_PATH } from '../constants/Config';
import { QRCodeSVG } from 'qrcode.react';
import './style/print.css';

export default class PrintLabel extends Component {
  constructor(props) {
    super(props);
    this.state = props;
  }

  render() {
    const numberZipcode = [1, 2, 3, 4, 5];
    return (
      <div ref={this.props.ref}>
        {_.map(this.props.parcel, (parcelNO, index) => {
          return (
            <div className='printable' style={{ padding: '10px' }}>
              <div
                style={{
                  width: '830px',
                  height: '540px',
                }}
              >
                <div>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      padding: '24px',
                    }}
                  >
                    <div>
                      <img src={`${ASSET_BASE_PATH}/assets/loop.png`} width={150} style={{ margin: 0 }} />
                    </div>
                    <div>
                      <img src={`${ASSET_BASE_PATH}/assets/loopContact2.png`} width={270} height={60}  style={{ margin: 0 }} />
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    padding: '0px 24px',
                  }}
                >
                  <div
                    style={{
                      border: '2px solid',
                      height: '370px',
                    }}
                  >
                    <div
                      style={{
                        height: '115px',
                        borderBottom: '2px solid',
                        padding: '10px 24px',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '24px',
                          fontWeight: 'bold',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span>ผู้ส่ง : {_.get(this.props.info, 'customer.comtomerName')}</span>
                        <span style={{ marginLeft: '8px' }}>{this.props.phone}</span>
                      </div>
                      <div
                        className='address'
                        style={{
                          marginTop: '8px',
                          fontWeight: 'bold',
                          fontSize: '18px',
                          overflow: 'hidden',
                        }}
                      >
                        {_.get(this.props.info, 'source.address')}
                      </div>
                    </div>
                    <div
                      style={{
                        height: '105px',
                        // borderBottom: '2px solid',
                        padding: '10px 24px',
                      }}
                    >
                      <div
                        style={{
                          fontSize: '24px',
                          fontWeight: 'bold',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span>ผู้รับ : {_.get(this.props.info, 'contact.customerContactName')}</span>
                        <span style={{ marginLeft: '8px' }}>{_.get(this.props.info, 'contact.customerContactPhone')}</span>
                      </div>
                      <div
                        class='address'
                        style={{
                          marginTop: '8px',
                          fontWeight: 'bold',
                          fontSize: '18px',
                        }}
                      >
                        {_.get(this.props.info, 'destination.address')}
                        {/* {_.get(this.props.info, 'destination.address')} */}
                      </div>
                    </div>
                    <div
                      style={{
                        height: '50px',
                      }}
                    >
                      <Row>
                        <Col span={19} style={{padding: '10px 0px 10px 24px'}}>
                          <div
                            className='divZip'
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              justifyContent: 'start',
                              marginTop: '15px',
                            }}
                          >
                            {_.map(numberZipcode, (number, index) => {
                              return (
                                <Row key={number}>
                                  <Col>
                                    <div
                                      style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        backgroundColor: '#fff',
                                        height: '85px',
                                        width: '65px',
                                        marginLeft: '8px',
                                        textAlign: 'center',
                                        fontSize: '56px',
                                        fontWeight: 'bold',
                                        border: 'solid 2px',
                                      }}
                                    >
                                      {this.props.zipcode[index]}
                                    </div>
                                  </Col>
                                </Row>
                              );
                            })}
                          </div>
                        </Col>
                        <Col span={5}>
                          <div
                            style={{
                              height: '147px',
                              width: '100%',
                              borderLeft: 'solid 2px',
                              borderTop: 'solid 2px',
                              marginBottom: '0px',
                            }}
                          >
                            <div
                              style={{
                                fontSize: '14px',
                                fontWeight: 'bold',
                                textAlign: 'center',
                                paddingTop: '4px',
                              }}
                            >
                              Parcel No.
                              <div style={{ textAlign: 'center' }}>
                                <QRCodeSVG
                                  class='qrcode'
                                  style={{ marginTop: '4px', marginBottom: '0px', width: '105px', height: '75px' }}
                                  value={_.get(parcelNO, 'parcelNo')}
                                />
                              </div>
                              <div>
                            {_.get(parcelNO, 'parcelNo')}
                            </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}
